import { i18n } from '../../../i18n-handler/handler/i18n';
import { IDateList } from '../../../interfaces/dates/IDateList';

let lang = 'fr';

/**
 * Generate a list of years from 2016 to active year
 * @example in 2020 the list will be from 2020->2016
 * @example in December 2020 the list will be from 2021->2016
 */
function getYearsList(): IDateList[] {
    const res = [];
    const activityStarted = 2016;
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    if (currentMonth === 11) {
        const next_year = currentYear + 1;
        res.push({
            display: `${next_year}`,
            value: `${next_year}`,
        });
    }

    for (let activeYear = currentYear; activityStarted <= activeYear; activeYear--) {
        res.push({
            display: `${activeYear}`,
            value: `${activeYear}`,
        });
    }

    return res;
}

function getMonthList(): IDateList[] {
    return [
        {
            value: '01',
            display: i18n.t('dates.months.01', { lng: lang }),
        },
        {
            value: '02',
            display: i18n.t('dates.months.02', { lng: lang }),
        },
        {
            value: '03',
            display: i18n.t('dates.months.03', { lng: lang }),
        },
        {
            value: '04',
            display: i18n.t('dates.months.04', { lng: lang }),
        },
        {
            value: '05',
            display: i18n.t('dates.months.05', { lng: lang }),
        },
        {
            value: '06',
            display: i18n.t('dates.months.06', { lng: lang }),
        },
        {
            value: '07',
            display: i18n.t('dates.months.07', { lng: lang }),
        },
        {
            value: '08',
            display: i18n.t('dates.months.08', { lng: lang }),
        },
        {
            value: '09',
            display: i18n.t('dates.months.09', { lng: lang }),
        },
        {
            value: '10',
            display: i18n.t('dates.months.10', { lng: lang }),
        },
        {
            value: '11',
            display: i18n.t('dates.months.11', { lng: lang }),
        },
        {
            value: '12',
            display: i18n.t('dates.months.12', { lng: lang }),
        },
    ];
}

/**
 * keys to be kept
 * i18n.t('dates.days.0')
 * i18n.t('dates.days.1')
 * i18n.t('dates.days.2')
 * i18n.t('dates.days.3')
 * i18n.t('dates.days.4')
 * i18n.t('dates.days.5')
 * i18n.t('dates.days.6')
 * i18n.t('dates.days.monday')
 * i18n.t('dates.days.short-monday')
 * i18n.t('dates.days.tuesday')
 * i18n.t('dates.days.short-tuesday')
 * i18n.t('dates.days.wednesday')
 * i18n.t('dates.days.short-wednesday')
 * i18n.t('dates.days.thurday')
 * i18n.t('dates.days.short-thurday')
 * i18n.t('dates.days.friday')
 * i18n.t('dates.days.short-friday')
 * i18n.t('dates.days.saturday')
 * i18n.t('dates.days.short-saturday')
 * i18n.t('dates.days.sunday')
 * i18n.t('dates.days.short-sunday')
 */

export type DataReturn = {
    getYearsList: Function;
    getMonthList: Function;
};

export const data = (_lang = 'fr'): DataReturn => {
    lang = _lang;
    return {
        getYearsList,
        getMonthList,
    };
};
